import TAO_KOE from './_TAO_KOE.js';
import { EN, EN_KO } from './_EN_KO.js';

import TaoCookieJar from './TaoCookieJar.js';
import TaoStorage from './Storage.js';
import TaoConsole from './TaoConsole.js';
import TaoToaster from './TaoToaster.js';
import TaoTrigger from './TaoTrigger.js';
import TaoPromise from './TaoPromise.js';
import getDispatchUrl from './Dispatch.js';
import TaoReady from './Ready.js';
import DialogTrigger from './DialogTrigger.js';
import DynamicYieldAPI from './DynamicYield.js';

// Libs.
TAO_KOE.CookieJar = TaoCookieJar;
TAO_KOE.Storage = TaoStorage;
TAO_KOE.console = TaoConsole;
TAO_KOE.Toaster = TaoToaster;
TAO_KOE.Trigger = TaoTrigger;
TAO_KOE.Promise = TaoPromise;
TAO_KOE.getDispatchUrl = getDispatchUrl;

// Ready Events.
TAO_KOE.ready = TaoReady.ready;
TAO_KOE.promiseChain = TaoReady.promiseChain;
TAO_KOE.chainReady = TaoReady.chainReady;

TAO_KOE.open_popup = function( popupEl ) {
	return EN_KO.functions.open_popup( popupEl );
};

TAO_KOE.close_popup = function( popupEl = undefined, returnValue = '' ) {
	return EN_KO.functions.close_popup( popupEl, returnValue );
};

// Export TAO_KOE to window.
window.TAO_KOE = TAO_KOE;

const Render = EN.Render;
const Cookies = EN.Cookies;

export {
	TAO_KOE,
	EN,
	EN_KO,
	Render,
	Cookies,
	TaoCookieJar,
	TaoStorage,
	TaoConsole,
	TaoToaster,
	getDispatchUrl,
	TaoReady,
	DialogTrigger,
	TaoTrigger,
	TaoPromise,
	DynamicYieldAPI,
};
